'use client'

import React from 'react'

const OfferingsSection = () => {
  const offerings = [
    {
      title: "Webinar & Workshops",
      features: [
        "Get to know the mentor",
        "Get an Insight into the Program",
        "Understand your Career Path",
        "Live Q&A session"
      ]
    },
    {
      title: "Mentorship Programs", 
      features: [
        "Watch videos at your own pace",
        "Live sessions to resolve doubts",
        "Learn with hands-on Projects",
        "Special guest sessions"
      ]
    }
  ]

  const CheckIcon = () => (
    <img 
      src="https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsgreen.svg"
      alt="Check"
      width="20"
      height="20"
      className="flex-shrink-0"
    />
  )

  const DecorationShape = () => (
    <img 
      src="https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gslogo.svg"
      alt="Decoration"
      width="160"
      height="160"
      className="absolute bottom-0 right-0 "
    />
  )

  return (
    <div className="w-full py-10 md:py-20">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 md:mb-12">
          <p className="text-sm md:text-base uppercase font-medium tracking-wide text-gray-600 mb-4">
            TAILORED LEARNING EXPERIENCES
          </p>
          <h2 className="text-3xl md:text-[36px] font-medium mb-8">
            Our Offerings
          </h2>
        </div>

        {/* Desktop - Side by Side Cards */}
        <div className="hidden md:flex gap-6">
          {offerings.map((offering, index) => (
            <div 
              key={index}
              className="flex-1 text-white rounded-2xl p-8 relative overflow-hidden"
              style={{ backgroundColor: '#002726' }}
            >
              <DecorationShape />
              
              <div className="relative z-10">
                <h3 className="text-2xl font-medium mb-6">
                  {offering.title}
                </h3>
                
                <div className="grid grid-cols-2 gap-4">
                  {offering.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center gap-3">
                      <CheckIcon />
                      <span className="text-base font-normal">
                        {feature}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile - Stacked Cards */}
        <div className="md:hidden space-y-6">
          {offerings.map((offering, index) => (
            <div 
              key={index}
              className="text-white rounded-2xl p-6 relative overflow-hidden"
              style={{ backgroundColor: '#002726' }}
            >
              <DecorationShape />
              
              <div className="relative z-10">
                <h3 className="text-xl font-medium mb-6">
                  {offering.title}
                </h3>
                
                <div className="space-y-4">
                  {offering.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-start gap-3">
                      <CheckIcon />
                      <span className="text-sm font-normal">
                        {feature}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default OfferingsSection